import { NeonSign } from "../components/NeonSign";
import { PageLinks } from "../components/PageLinks";
import { Reveal } from "../components/Reveal";
import { afterparty } from "../content/wedding";

export function Afterparty() {
  return (
    <main class="page motion-quiet page--tight afterparty" id="top">
      <section class="section afterparty-head">
        <div class="shell">
          <div class="afterparty-head__sign">
            <h1 class="neon">
              <span class="visually-hidden">{afterparty.title}</span>
              <NeonSign />
            </h1>
          </div>

          <div class="afterparty-head__invitation">
            <Reveal class="afterparty-head__copy">
              <h2 class="afterparty-head__title">The night’s<br />just getting started.</h2>
              <p class="serif-lead">{afterparty.lead}</p>
            </Reveal>
            <Reveal class="afterparty-head__details" delay={120}>
              <dl class="afterparty-details">
                <div>
                  <dt>Details to come</dt>
                  <dd>{afterparty.update}</dd>
                </div>
                <div>
                  <dt>The invitation</dt>
                  <dd>{afterparty.note}</dd>
                </div>
              </dl>
            </Reveal>
          </div>
          <p class="afterparty-head__last-call"><span>Let’s keep the good times going</span></p>
        </div>
      </section>
      <PageLinks />
    </main>
  );
}
